var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0519 39.1827C15.0519 43.0623 11.9055 46.2086 8.02594 46.2086C4.14634 46.2086 1 43.0623 1 39.1827V1H15.0452V39.1827H15.0519Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03284 43.2956C10.3043 43.2956 12.1457 41.4542 12.1457 39.1827C12.1457 36.9112 10.3043 35.0698 8.03284 35.0698C5.76134 35.0698 3.91992 36.9112 3.91992 39.1827C3.91992 41.4542 5.76134 43.2956 8.03284 43.2956Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87937 6.49268H3.35938V9.01265H5.87937V6.49268Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6987 6.49268H10.1787V9.01265H12.6987V6.49268Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00684 14.5652H15.052",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03223 18.5981V31.3701",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6973 33.53V44.7822",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8644 54.1544L26.0511 61.7069C25.7111 63.1334 23.6777 63.1334 23.3377 61.7069L21.5244 54.1544V4.17293C21.5244 2.42644 22.9444 1.00659 24.6911 1.00659C26.4377 1.00659 27.8577 2.42644 27.8577 4.17293V54.1544H27.8644Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 54.1545H27.8646",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 50.4348H27.8646",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 5.9729H27.8646",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6973 62.6868V64.9934",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4774 5.9729C19.8574 5.9729 18.5508 7.28611 18.5508 8.89927V19.9048",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9568 65H56.8545L56.8545 33.7499H34.9568V65Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8545 57.514C61.354 57.514 65.0003 53.8677 65.0003 49.3682C65.0003 44.8687 61.354 41.2224 56.8545 41.2224",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8545 53.6679C59.2278 53.6679 61.1545 51.7415 61.1545 49.3684C61.1545 46.9953 59.2278 45.0688 56.8545 45.0688",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9093 44.004L40.54 49.3733L45.9093 54.7426L51.2786 49.3733L45.9093 44.004Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03278 64.9999C11.9131 64.9999 15.0587 61.8543 15.0587 57.974C15.0587 54.0936 11.9131 50.948 8.03278 50.948C4.15246 50.948 1.00684 54.0936 1.00684 57.974C1.00684 61.8543 4.15246 64.9999 8.03278 64.9999Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03225 61.4204C9.9356 61.4204 11.4785 59.8775 11.4785 57.9741C11.4785 56.0708 9.9356 54.5278 8.03225 54.5278C6.12891 54.5278 4.58594 56.0708 4.58594 57.9741C4.58594 59.8775 6.12891 61.4204 8.03225 61.4204Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9089 28.2905C53.445 28.2905 59.5542 22.1813 59.5542 14.6452C59.5542 7.10918 53.445 1 45.9089 1C38.3729 1 32.2637 7.10918 32.2637 14.6452C32.2637 22.1813 38.3729 28.2905 45.9089 28.2905Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2755 11.1122L45.9088 11.4789L45.5422 11.1122C45.2156 10.7856 44.8356 10.5256 44.4023 10.3323C43.9624 10.139 43.5024 10.0457 43.0158 10.0457C42.5292 10.0457 42.0359 10.139 41.5959 10.3323C41.156 10.5256 40.776 10.7856 40.4561 11.1122C40.1294 11.4389 39.8761 11.8188 39.6962 12.2521C39.5162 12.692 39.4229 13.152 39.4229 13.6386C39.4229 14.1252 39.5162 14.6185 39.6962 15.0585C39.8761 15.4984 40.1361 15.8784 40.4561 16.1984L45.9155 21.6244L51.3749 16.1984C51.7015 15.8717 51.9549 15.4918 52.1348 15.0585C52.3148 14.6185 52.4082 14.1519 52.4082 13.6386C52.4082 13.1253 52.3148 12.6854 52.1348 12.2521C51.9549 11.8121 51.6949 11.4322 51.3749 11.1122C51.0549 10.7923 50.6683 10.5256 50.2351 10.3323C49.7951 10.139 49.3285 10.0457 48.8152 10.0457C48.3019 10.0457 47.862 10.139 47.4287 10.3323C46.9887 10.5256 46.6088 10.7856 46.2888 11.1122H46.2755Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingMobile);
export default __webpack_public_path__ + "static/media/marketing_mobile.23686284e5342640bd7cd6023cfdcc3c.svg";
export { ForwardRef as ReactComponent };